export default "__VITE_ASSET__Bcqf1Y8y__"